module.exports = __webpack_public_path__ + "img/Dai-lr-cb-1-l2.ee1f7607.png";